
//Libraries
import { defineComponent, onMounted, ref } from "vue";

//Type
import { ModalMutationOptions } from "../../shared/types/enum/store-enum";

//Store
import { useStore } from "../../store/index";

//Composables
import useRandom from "../../shared/composables/useRandom";

//Components
import NavBar from "../../shared/components/Nav.vue";
import AccountData from "./AccountData.vue";
import FeaturedUsers from "./FeaturedUsers.vue";
import GamesContent from "./GamesContent.vue";
import GameRounds from "./GameRounds.vue";

export default defineComponent({
  name: "HomeModule",
  components: {
    NavBar,
    AccountData,
    FeaturedUsers,
    GamesContent,
    GameRounds,
  },
  setup() {
    //Data
    const store = useStore();

    const isLoading = ref<boolean>(true);

    const gamesCount = ref<number>(0);
    const usersCount = ref<number>(0);

    //Use

    const { randomNumber, runRandom, stopRandom } = useRandom();

    //Methods

    const getAppData = async (): Promise<boolean> => {
      return true;
    };

    const createGame = () => {
      store.commit(ModalMutationOptions.activateModal, {
        size: "min",
        title: "Creando Juego",
        component: () => import("../../shared/components/game/GameCreator.vue"),
      });
    };

    const accessRound = () => {
      store.commit(ModalMutationOptions.activateModal, {
        size: "min",
        title: "Acceder a Juego",
        component: () => import("../../shared/components/game/GameAccess.vue"),
      });
    };

    //Lifecycle Hooks

    window.scrollTo(0, 0);

    onMounted(() => {
      runRandom();
      getAppData().then(() => {
        setTimeout(() => {
          stopRandom();
          gamesCount.value = 100; //data;
          usersCount.value = 50; //data;
          isLoading.value = false;
        }, 1000);
      });
    });

    return {
      //Data
      isLoading,
      randomNumber,
      gamesCount,
      usersCount,
      //Methods
      createGame,
      accessRound,
    };
  },
});
